import { useContext, useCallback } from "react";
import SidebarContext from "./SidebarContext";

/**
 * Hook to manage synced fields (runtime + emitted data)
 * Similar to useSyncedField in Wizard
 *
 * Values are stored in both runtimeData (for immediate UI updates) and emittedData (for final persistence)
 *
 * @param {string} fieldName - Name of the field
 * @param {*} defaultValue - Default value if field not set
 * @returns {Array} [value, setValue] tuple
 */
const useSyncedField = (fieldName, defaultValue = null) => {
    const { runtimeData, setRuntimeData, setEmittedData } =
        useContext(SidebarContext);

    const value = runtimeData[fieldName] ?? defaultValue;

    const setValue = useCallback(
        (newValue) => {
            // Update both runtime and emitted data in sync
            setRuntimeData((prev) => ({
                ...prev,
                [fieldName]: newValue,
            }));
            setEmittedData((prev) => ({
                ...prev,
                [fieldName]: newValue,
            }));
        },
        [fieldName, setRuntimeData, setEmittedData]
    );

    return [value, setValue];
};

export default useSyncedField;
